import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

let lenis = null;

const EASE_OUT_QUART = (t) => 1 - Math.pow(1 - t, 4);
const NAV_OFFSET = -112;
const GLIDE = { duration: 1.6, easing: EASE_OUT_QUART };

export const scrollToSection = (hash) => {
  if (lenis) {
    lenis.scrollTo(hash, { offset: NAV_OFFSET, ...GLIDE });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function SmoothScroll() {
  const location = useLocation();

  useEffect(() => {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true, easing: EASE_OUT_QUART });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenis = null;
    };
  }, []);

  useEffect(() => {
    if (!lenis) return;
    if (location.hash) {
      const t = setTimeout(
        () => lenis?.scrollTo(location.hash, { offset: NAV_OFFSET, ...GLIDE }),
        350
      );
      return () => clearTimeout(t);
    }
    lenis.scrollTo(0, { immediate: true });
  }, [location.pathname, location.hash]);

  return null;
}
